// AP2-6952: Lease Domain's POST .../generate rejects with a JSON body `{ errorCode, message }`. The
// associate used to see only "Error generating lease, please try again" whatever the reason, so a
// rejection that no retry can clear (e.g. MOVE_IN_DATE_NOT_IN_FUTURE) looked like a transient
// failure. Known codes get associate-facing wording; an unknown one falls back to Lease Domain's own
// message so the reason is still shown.
export const GENERIC_GENERATE_LEASE_ERROR = "Error generating lease, please try again";

const GENERATE_LEASE_ERROR_MESSAGES: Record<string, string> = {
  MOVE_IN_DATE_NOT_IN_FUTURE:
    "The move-in date must be in the future to generate a lease. Update the move-in date and try again.",
  CAN_GENERATE_LEASE_FALSE:
    "This application is not eligible to generate a lease right now.",
  APPLICATION_NOT_APPROVED:
    "The application must be approved before a lease can be generated.",
  PHASE_NOT_ENABLED: "Lease generation is not enabled for this community.",
  GENERATION_ALREADY_IN_PROGRESS:
    "Lease generation is already in progress for this application.",
  GENERATION_FAILED_NEEDS_REVIEW:
    "A previous lease generation failed and needs review before the lease can be generated again.",
  PRIOR_CONTRACT_NOT_RECONCILED:
    "The previous lease has not synced from MRI yet. Please try again in a few minutes.",
  MRI_MOVE_IN_DATE_UNAVAILABLE:
    "Could not read the move-in date from MRI. Please try again.",
  PREVIOUS_LEGAL_RENT_REQUIRED:
    "Enter the previous legal regulated rent to generate this lease.",
  RNT_CHARGE_NOT_FOUND:
    "The application has no rent charge, so the lease cannot be generated.",
  LEASE_TERM_INVALID:
    "The application's lease term is not valid, so the lease cannot be generated.",
  EXISTING_CONTRACT_STALE:
    "The application changed since the last attempt. Please try again.",
};

/** Associate-facing text for a failed Lease Domain generate response body. */
export const getGenerateLeaseErrorMessage = (responseBody: string): string => {
  let parsed: { errorCode?: unknown; message?: unknown } | null = null;
  try {
    parsed = JSON.parse(responseBody);
  } catch {
    return GENERIC_GENERATE_LEASE_ERROR;
  }

  const errorCode =
    typeof parsed?.errorCode === "string" ? parsed.errorCode : undefined;
  if (errorCode && GENERATE_LEASE_ERROR_MESSAGES[errorCode]) {
    return GENERATE_LEASE_ERROR_MESSAGES[errorCode];
  }

  const message =
    typeof parsed?.message === "string" ? parsed.message.trim() : "";
  return message
    ? `Error generating lease: ${message}`
    : GENERIC_GENERATE_LEASE_ERROR;
};
